import { render, staticRenderFns } from "./StatisticsTicketError.vue?vue&type=template&id=74b8c4c0&scoped=true&"
import script from "./StatisticsTicketError.vue?vue&type=script&lang=js&"
export * from "./StatisticsTicketError.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTicketError.vue?vue&type=style&index=0&id=74b8c4c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8c4c0",
  null
  
)

export default component.exports